import { render, staticRenderFns } from "./ChipAvatar.vue?vue&type=template&id=75da9be8"
import script from "./ChipAvatar.vue?vue&type=script&lang=js"
export * from "./ChipAvatar.vue?vue&type=script&lang=js"
import style0 from "./ChipAvatar.vue?vue&type=style&index=0&id=75da9be8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports